import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from './Login&Register.module.css';
import { API_BASE_URL } from './Common';
import { ReactComponent as LoginIcon } from '../icons/login.svg';
import { ReactComponent as ProchildIcon } from '../icons/prochild.svg';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${API_BASE_URL}/login`, { email, password });
      const token = response.data.token;
      localStorage.setItem('token', token);
      window.location.href = '/home';
    } catch (error) {
      //if (error.response.status === 401) console.log("Invalid email or password");
      if (error.response.status === 403) navigate('/register', { state: { email } });//console.log("user unverified");

      if (error.response) {
        setError('Invalid email or password. Please try again.');
        document.getElementById("email").classList.add(styles.inputError);
        document.getElementById("password").classList.add(styles.inputError);
      } else if (error.request) {
        setError('Network error. Please try again later.');
      } else {
        setError('Unexpected error. Please try again later.');
      }
    }
  };

  return (
    <div className={styles.loginWrapper}>
      <div className={styles.loginContainer}>
        <ProchildIcon />
        <div className={styles.bigText}>Login</div>
        <p className={styles.welcomeText}>Bem-vindo novamente! Insira as suas informações.</p>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label>E-mail</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Inserir e-mail"
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label>Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Inserir password"
              required
            />
          </div>
          <div className={styles.linkContainer}>
            <Link to="/password-recovery" className={styles.myLinks}>Esqueceu-se da password?</Link>
          </div>
          {/*
          {error && <p className={styles.errorMessage}>{error}</p>}
          */}
          <button type="submit" className={styles.loginBtn}>Entrar</button>
        </form>
        <div className={styles.linkContainer}>
          <Link to="/register" className={styles.myLinks}>Criar conta?</Link>
        </div>
      </div>
      <LoginIcon className={styles.loginIcon} />
    </div>
  );
}

export default Login;
